var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mySharesCount > 0)?_c('div',{class:_vm.classModifiers},[_c('button',{staticClass:"button button--primary dashboard-markets-toggle__button",on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}},[_vm._v(_vm._s(_vm.buttonText))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d83fd36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/dashboard-markets-toggle/dashboard-markets-toggle.vue
// module id = Iu3W
// module chunks = 0